var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.loggedIn)?_c('Default'):_c('HomeNotLoggedIn')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }